import React from 'react';
import { LocalTrackPublication, Participant, RemoteTrackPublication, Track } from 'twilio-video';
import { useTrack } from 'hooks';
import { IVideoTrack } from 'types';
import { AudioTrack, VideoTrack } from 'components';

interface PublicationProps {
  publication: LocalTrackPublication | RemoteTrackPublication;
  participant: Participant;
  isLocalParticipant?: boolean;
  videoOnly?: boolean;
  videoPriority?: Track.Priority | null;
  zoomScale?: number;
  panOffset?: {
    x: number;
    y: number;
  };
  canPan?: boolean;
}

export function Publication({
  publication,
  isLocalParticipant,
  videoPriority,
  zoomScale,
  panOffset,
  canPan,
}: PublicationProps) {
  const track = useTrack(publication);

  if (!track) return null;

  // Even though we only have one case here, let's keep this switch() in case
  // we even need to add a 'data' case for rendering DataTracks.
  switch (track.kind) {
    case 'video':
      return (
        <VideoTrack
          track={track as IVideoTrack}
          priority={videoPriority}
          isLocal={!track.name.includes('screen') && isLocalParticipant}
          zoomScale={zoomScale}
          panOffset={panOffset}
          canPan={canPan}
        />
      );
    case 'audio':
      if (track.name === 'screen_audio') {
        return <AudioTrack track={track} />;
      }
      return null;
    // All other participant audio tracks are rendered in ParticipantAudioTracks.tsx
    default:
      return null;
  }
}
